import React, { useEffect, useState } from 'react'
import BossDialog from '../../../components/BossDialog'
import { useTranslation } from '../../../locale/useTranslation';
import { EditPageHeader } from '../../../components/EditPageHeader';
import { utility } from '../../../framework/utility/utilityProvider';
import * as API from '../../../framework/API/api';
import { ENTITYNAME, TOAST_TYPES, TRANSMISSION_ACTION } from '../../../framework/constant/constant';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import moment from 'moment';
import ToastNotification from '../../../components/ToastNotification';
import MyMultiSelect from '../../../components/MyMultiSelect';
import { ConfirmDeleteAlert } from '../../../ConfirmAlert';

const EditTransmissonForm = (props) => {

    const { onClose, data = [], setDataList, isActionEdit = false } = props;

    const lang = useTranslation();

    const item = data?.length === 1 ? data[0] : {};
    const blankDataItem = {
        startDate: item.startDate ? moment.utc(item.startDate).format('YYYY-MM-DDTHH:mm') : '',
        endDate: item.endDate ? moment.utc(item.endDate).format('YYYY-MM-DDTHH:mm') : '',
        ottPlatforms: item?.ott_platforms?.length > 0 ? item.ott_platforms : []
    }

    if (isActionEdit && item.action) {
        blankDataItem.action = { _id: item.action, Description: utility.getKeyByValue(TRANSMISSION_ACTION, item.action) };
    }

    const [ottPlatforms, setOttPlatforms] = useState([]);
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [updateFields, setUpdateFields] = useState({
        startDate: data?.length === 1,
        endDate: data?.length === 1,
        ottPlatforms: data?.length === 1
    });

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let ottPlatformRes = await API.getDataLookup(ENTITYNAME.Platform, { query: ["Archive", "!=", true] });
        setOttPlatforms(ottPlatformRes?.data ?? []);
    }

    const handleSubmit = async () => {

        let finalData = {
            action: TRANSMISSION_ACTION.Update
        }

        if (updateFields.startDate) {
            if (!dataItem.startDate) {
                return ToastNotification({ type: TOAST_TYPES.WARNING, title: lang.warning_message_title, message: `${lang.start_date_label} is required` });
            }
            finalData.startDate = moment.utc(dataItem.startDate).valueOf();
        }

        if (updateFields.endDate) {
            if (!dataItem.endDate) {
                return ToastNotification({ type: TOAST_TYPES.WARNING, title: lang.warning_message_title, message: `${lang.end_Date_label} is required` });
            }
            finalData.endDate = moment.utc(dataItem.endDate).valueOf();
        }

        if (updateFields.ottPlatforms) {
            if (!dataItem.ottPlatforms || dataItem.ottPlatforms.length === 0) {
                return ToastNotification({ type: TOAST_TYPES.WARNING, title: lang.warning_message_title, message: `${lang.ott_platform_label} is required` });
            }
            finalData.ott_platforms = dataItem?.ottPlatforms?.length > 0 ? dataItem?.ottPlatforms?.map(x => {
                return { _id: x._id, Description: x.Description }
            }) : [];
        }

        if (!updateFields.startDate && !updateFields.endDate && !updateFields.ottPlatforms) {
            return ToastNotification({ type: TOAST_TYPES.WARNING, title: lang.warning_message_title, message: lang.please_select_at_least_one_field_to_update_error_message });
        }

        let finalDataQuery = []
        if (data.length > 0) {
            finalDataQuery = data.filter(x => x?.action !== TRANSMISSION_ACTION.Delete)?.map(x => x?._id);
        }

        if (finalDataQuery.length === 0) return onClose();

        let res = await API.updateTransmission({ query: ['_id', 'in', finalDataQuery], data: finalData });
        console.log(res);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            setDataList(finalDataQuery, finalData);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        onClose();
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const onUpdateFieldChange = (e) => {
        setUpdateFields({ ...updateFields, [e.target.name]: e.target.checked });
    }

    const handleActionSubmit = async () => {
        if (dataItem?.action?._id === TRANSMISSION_ACTION.Delete) {
            ConfirmDeleteAlert(
                () => submitAction(),
                () => { }
            );
        } else {
            await submitAction();
        }
    }

    const submitAction = async () => {

        let finalData = {
            action: dataItem.action?._id
        }
        let ids = data.map(x => x?._id);
        let res = await API.updateTransmission({ query: ['_id', 'in', ids], data: finalData });
        console.log(res);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            setDataList(ids, finalData);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        onClose();
    }



    return (
        <BossDialog title="Edit Transmissions" width='350px' onClose={onClose}>
            <EditPageHeader showTitle={false} saveButtonTitle={lang.save_button_text} onSubmit={isActionEdit ? handleActionSubmit : handleSubmit} onCancel={onClose} />
            {isActionEdit ? <div className='row'>
                <div className='col-12 mt-2'>
                    <label>{lang.action_label} *</label>
                    <DropDownList
                        data={Object.keys(TRANSMISSION_ACTION).filter(key => [TRANSMISSION_ACTION.Update, TRANSMISSION_ACTION.Delete].includes(TRANSMISSION_ACTION[key])).map(key => ({ _id: TRANSMISSION_ACTION[key], Description: key }))}
                        name="action"
                        dataItemKey="_id"
                        textField="Description"
                        value={dataItem.action}
                        onChange={onChange}
                    />
                </div>
            </div> : <>
                <div className='row'>
                    <div className='col-12 mt-2'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <label>{lang.start_date_label} *</label>
                            <label className='mb-0' style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                <input type="checkbox" className='mr-1' name="startDate" checked={updateFields.startDate} onChange={onUpdateFieldChange} />
                                {lang.update_label}
                            </label>
                        </div>
                        <input type="datetime-local" className="form-control form-control-sm" name="startDate" value={dataItem.startDate} onChange={onChange} disabled={!updateFields.startDate} />
                    </div>
                    <div className='col-12 mt-2'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <label>{lang.end_Date_label} *</label>
                            <label className='mb-0' style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                <input type="checkbox" className='mr-1' name="endDate" checked={updateFields.endDate} onChange={onUpdateFieldChange} />
                                {lang.update_label}
                            </label>
                        </div>
                        <input type="datetime-local" className="form-control form-control-sm" name="endDate" value={dataItem.endDate} onChange={onChange} disabled={!updateFields.endDate} />
                    </div>
                    <div className='col-12 mt-2'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <label>{lang.platform_label} *</label>
                            <label className='mb-0' style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                <input type="checkbox" className='mr-1' name="ottPlatforms" checked={updateFields.ottPlatforms} onChange={onUpdateFieldChange} />
                                {lang.update_label}
                            </label>
                        </div>
                        <MyMultiSelect
                            data={ottPlatforms}
                            name="ottPlatforms"
                            dataItemKey="_id"
                            textField="Description"
                            value={dataItem.ottPlatforms}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <p className='mt-4 text-danger' style={{ marginBottom: "-8px" }}>* {lang.transmissions_edit_note}</p>
            </>}
        </BossDialog>
    )
}

export default EditTransmissonForm;
